import { CustomError } from 'shared/errors';

export class DialogException extends CustomError {}
